<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Partner Master Data</div>
        <div>
          <bread-crumb :bread-crumbs="['Partner MaterData']" />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="data"
        :search="search"
        item-key="name"
      >
        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-col class="mt-5">
            <v-row>
              <v-col cols="12" md="3" lg="3" xs="12">
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  :items="partnerList"
                  item-text="txt"
                  item-value="val"
                  placeholder="Partner code"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-btn depressed 
                  small
                  class="text-capitalize mt-1 text-decoration-none"
                  color="primary"
                  ><v-icon class="me-1">mdi-content-save-check </v-icon>Save
                  All</v-btn
                ></v-col
              >
              <v-col></v-col>
            </v-row>
            <!-- <v-row>
              <v-col></v-col>
              <v-col cols="12" md="4"
                ><v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Type here to filter the table data."
                  hide-details
                  class="me-4 mb-2"
                  dense
                  clearable
                ></v-text-field
              ></v-col>
            </v-row> -->
          </v-col>
        </template>
        <template v-slot:item.static_value="{ item }">
          <span
            >{{ item.static_value.static_value }} -
            {{ item.static_value.static_name }}</span
          >
        </template>
        <template v-slot:item.partner_value="{ item }">
          <v-text-field
            v-model="item.partner_value"
            placeholder="Enter Value"
            hide-details
            outlined
            class="me-4 mb-2"
            dense
          ></v-text-field>
        </template>
        <template v-slot:item.partner_code="{ item }">
          <v-text-field
            v-model="item.partner_code"
            placeholder="Enter value code"
            hide-details
            outlined
            class="me-4 mb-2"
            dense
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn depressed 
              icon
              @click="deleteItem(item)"
              title="Save Data"
              color="primary"
            >
              <v-icon> mdi-content-save-check </v-icon>
            </v-btn>
            <v-btn depressed 
              icon
              @click="deleteItem(item)"
              title="Update Data"
              color="warning"
            >
              <v-icon> mdi-content-save-edit </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import userService from "@/services/UserService/userService.js";
export default {
  name: "Partner MaterData",
  mixins: [alerts],
  data() {
    return {
      loader: false,
      search: "",
      partnerList: [],
      data: [
        {
          static_value: {
            static_value: "1223",
            static_name: "MEDICAL EXPENSEs",
          },
          partner_value: "Health related",
          partner_code: 13400,
        },
        {
          static_value: {
            static_value: "19732",
            static_name: "EDUCATIONAL EXPENSEs",
          },
          partner_value: "Educational related",
          partner_code: 13500,
        },
      ],
      headers: [
        { text: "Static value", value: "static_value" },
        { text: "Partner value", value: "partner_value" },
        { text: "Partner code", value: "partner_code" },
        { text: "Action", value: "action", sortable: false },
      ],
    };
  },
  components: {
    BreadCrumb,
  },
  mounted() {
    this.getallpartners();
  },
  methods: {
    async getallpartners() {
      try {
        const response = await userService.getTotalPartners();
        if (response.data.status_code === 200) {
          const partners = response.data.data[0];
          partners.map((ele) => {
            this.partnerList.push({
              val: ele.short_code,
              text: ele.partner_name,
            });
          });
        } 
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallpartners();
        // }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
  },
};
</script>
<style></style>
